module.exports = __webpack_public_path__ + "img/part3@2x.579a79d7.png";